module.exports = __webpack_public_path__ + "/build/web/images/hero.85af19ea083ff4fcd15225fc9f9ac8f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero.jpg
// module id = 157
// module chunks = 13